export interface LandingNavItem {
    key: string;
    labelKey: string;
    sectionId?: string;
    href?: string;
    external?: boolean;
}

export const LANDING_SECTION_NAV_ITEMS: LandingNavItem[] = [
    { key: 'home', labelKey: 'navigation.home', sectionId: 'hero' },
    { key: 'demo', labelKey: 'navigation.demo', sectionId: 'demo' },
    { key: 'features', labelKey: 'navigation.features', sectionId: 'features' },
    { key: 'pricing', labelKey: 'navigation.pricing', sectionId: 'pricing' },
    { key: 'cta', labelKey: 'navigation.callToAction', sectionId: 'cta' },
];

export const LANDING_BLOG_NAV_ITEM: LandingNavItem = {
    key: 'blog',
    labelKey: 'navigation.blog',
    href: 'https://blog.minifil.com',
    external: true,
};

export const scrollToLandingSection = (sectionId: string): void => {
    const element = document.getElementById(sectionId);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
};
